import { render, staticRenderFns } from "./agreement.html?vue&type=template&id=3b1633b2&scoped=true&"
import script from "./agreement.js?vue&type=script&lang=js&"
export * from "./agreement.js?vue&type=script&lang=js&"
import style0 from "./agreement.scss?vue&type=style&index=0&id=3b1633b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1633b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1633b2')) {
      api.createRecord('3b1633b2', component.options)
    } else {
      api.reload('3b1633b2', component.options)
    }
    module.hot.accept("./agreement.html?vue&type=template&id=3b1633b2&scoped=true&", function () {
      api.rerender('3b1633b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/god-duck/agreement/agreement.vue"
export default component.exports